import {
  POST_APP_DYNAMICS_ENABLE_DISABLE_ALERTS,
  POST_APP_DYNAMICS_ENABLE_DISABLE_ALERTS_FAIL,
  POST_APP_DYNAMICS_ENABLE_DISABLE_ALERTS_SUCCESS,
  POST_APP_DYNAMICS_CREATE_RESOURCE_ALERTS,
  POST_APP_DYNAMICS_CREATE_RESOURCE_ALERTS_FAIL,
  POST_APP_DYNAMICS_CREATE_RESOURCE_ALERTS_SUCCESS,
  POST_APP_DYNAMICS_CREATE_DYNAMIC_ALERT,
  POST_APP_DYNAMICS_CREATE_DYNAMIC_ALERT_FAIL,
  POST_APP_DYNAMICS_CREATE_DYNAMIC_ALERT_SUCCESS,
  GET_APP_DYNAMICS_ALERTS,
  GET_APP_DYNAMICS_ALERTS_FAIL,
  GET_APP_DYNAMICS_ALERTS_SUCCESS, 
  GET_APP_DYNAMICS_DYNAMIC_ALERTS,
  GET_APP_DYNAMICS_DYNAMIC_ALERTS_FAIL,
  GET_APP_DYNAMICS_DYNAMIC_ALERTS_SUCCESS,
  GET_APP_DYNAMICS_MISSING_DYNAMIC_ALERTS,
  GET_APP_DYNAMICS_MISSING_DYNAMIC_ALERTS_FAIL,
  GET_APP_DYNAMICS_MISSING_DYNAMIC_ALERTS_SUCCESS,
  GET_APP_DYNAMICS_DEFAULT_THRESHOLD,
  GET_APP_DYNAMICS_DEFAULT_THRESHOLD_FAIL,
  GET_APP_DYNAMICS_DEFAULT_THRESHOLD_SUCCESS,
  GET_APP_DYNAMICS_RESOURCE_BY_ID,
  GET_APP_DYNAMICS_RESOURCE_BY_ID_FAIL,
  GET_APP_DYNAMICS_RESOURCE_BY_ID_SUCCESS,
  GET_APP_DYNAMICS_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
  GET_APP_DYNAMICS_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL,
  GET_APP_DYNAMICS_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS,
  POST_APP_DYNAMICS_ALERT,
  POST_APP_DYNAMICS_ALERT_FAIL,
  POST_APP_DYNAMICS_ALERT_SUCCESS,
  GET_APP_DYNAMICS_RESCAN,
  GET_APP_DYNAMICS_RESCAN_FAIL,
  GET_APP_DYNAMICS_RESCAN_SUCCESS,
  GET_APP_DYNAMICS_MISSING_ALERT_BY_RESOURCE_ID,
  GET_APP_DYNAMICS_MISSING_ALERT_BY_RESOURCE_ID_FAIL,
  GET_APP_DYNAMICS_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS,
  GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_PAGE,
  GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_COUNT_PAGE,
  GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL,
  GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS,
  POST_APP_DYNAMICS_SERVICE_MAPPING,
  POST_APP_DYNAMICS_SERVICE_MAPPING_FAIL,
  POST_APP_DYNAMICS_SERVICE_MAPPING_SUCCESS,
  POST_APP_DYNAMICS_RESOURCE_OPSGENIE_TEAM_MAPPING,
  POST_APP_DYNAMICS_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  POST_APP_DYNAMICS_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  POST_APP_DYNAMICS_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  POST_APP_DYNAMICS_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  POST_APP_DYNAMICS_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  GET_APP_DYNAMICS_RESOURCES,
  GET_APP_DYNAMICS_RESOURCES_FAIL,
  GET_APP_DYNAMICS_RESOURCES_SUCCESS,
  GET_ALL_ORG_APP_DYNAMICS_RESOURCE_TYPES,
  GET_ALL_ORG_APP_DYNAMICS_RESOURCE_TYPES_FAIL,
  GET_ALL_ORG_APP_DYNAMICS_RESOURCE_TYPES_SUCCESS,
  GET_RESCAN_STATUS_APP_DYNAMICS,
  GET_RESCAN_STATUS_APP_DYNAMICS_FAIL,
  GET_RESCAN_STATUS_APP_DYNAMICS_SUCCESS,
  POST_UPDATE_APP_DYNAMICS_THRESHOLD,
  POST_UPDATE_APP_DYNAMICS_THRESHOLD_FAIL,
  POST_UPDATE_APP_DYNAMICS_THRESHOLD_SUCCESS,
  POST_ENABLE_DISABLE_APP_DYNAMICS_THRESHOLD,
  POST_ENABLE_DISABLE_APP_DYNAMICS_THRESHOLD_FAIL,
  POST_ENABLE_DISABLE_APP_DYNAMICS_THRESHOLD_SUCCESS,
  GET_AD_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_AD_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_AD_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_APP_DYNAMICS_THRESHOLD,
  GET_APP_DYNAMICS_THRESHOLD_FAIL,
  GET_APP_DYNAMICS_THRESHOLD_SUCCESS,
    GET_APP_DYNAMICS_ALL_BUSINESS_TRANSACTIONS,
    GET_APP_DYNAMICS_ALL_BUSINESS_TRANSACTIONS_FAIL,
    GET_APP_DYNAMICS_ALL_BUSINESS_TRANSACTIONS_SUCCESS,
    GET_APP_DYNAMICS_ALL_EXTERNAL_SERVICES,
    GET_APP_DYNAMICS_ALL_EXTERNAL_SERVICES_FAIL,
    GET_APP_DYNAMICS_ALL_EXTERNAL_SERVICES_SUCCESS,
    GET_AD_NON_KEY_TRANSACTIONS,
    GET_AD_NON_KEY_TRANSACTIONS_FAIL,
    GET_AD_NON_KEY_TRANSACTIONS_SUCCESS,
    POST_MARK_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION,
    POST_MARK_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_FAIL,
    POST_MARK_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_SUCCESS,

 } from "./actionTypes";


export const postEnableDisableAppDynamicsThreshold = (data) => ({
  type: POST_ENABLE_DISABLE_APP_DYNAMICS_THRESHOLD,
  payload: data,
})

export const postEnableDisableAppDynamicsThresholdFail = error => ({
  type: POST_ENABLE_DISABLE_APP_DYNAMICS_THRESHOLD_FAIL,
  payload: error,
})

export const postEnableDisableAppDynamicsThresholdSuccess = (response) => ({
  type: POST_ENABLE_DISABLE_APP_DYNAMICS_THRESHOLD_SUCCESS,
  payload: response,
})

export const postUpdateAppDynamicsThreshold = (data) => ({
  type: POST_UPDATE_APP_DYNAMICS_THRESHOLD,
  payload: data
})

export const postUpdateAppDynamicsThresholdFail = error => ({
  type: POST_UPDATE_APP_DYNAMICS_THRESHOLD_FAIL,
  payload: error
})

export const postUpdateAppDynamicsThresholdSuccess = (response) => ({
  type: POST_UPDATE_APP_DYNAMICS_THRESHOLD_SUCCESS,
  payload: response
})

export const getRescanStatusAppDynamics = (data) => ({
  type: GET_RESCAN_STATUS_APP_DYNAMICS,
  payload: data
})

export const getRescanStatusAppDynamicsFail = error => ({
  type: GET_RESCAN_STATUS_APP_DYNAMICS_FAIL,
  payload: error
})

export const getRescanStatusAppDynamicsSuccess = (app_dynamics_rescan_status) => ({
  type: GET_RESCAN_STATUS_APP_DYNAMICS_SUCCESS,
  payload: app_dynamics_rescan_status
})

export const getAppDynamicsRescan = () => ({
  type: GET_APP_DYNAMICS_RESCAN,
  payload: []
})

export const getAppDynamicsRescanFail = error => ({
  type: GET_APP_DYNAMICS_RESCAN_FAIL,
  payload: error
})

export const getAppDynamicsRescanSuccess = (data) => ({
  type: GET_APP_DYNAMICS_RESCAN_SUCCESS,
  payload: data
})

export const getAppDynamicsResources = () => ({
  type: GET_APP_DYNAMICS_RESOURCES,
})

export const getAppDynamicsResourcesFail = error => ({
  type: GET_APP_DYNAMICS_RESOURCES_FAIL,
  payload: error
})

export const getAppDynamicsResourcesSuccess = app_dynamics_resources => ({
  type: GET_APP_DYNAMICS_RESOURCES_SUCCESS,
  payload: app_dynamics_resources
})

export const getAppDynamicsMissingAlertByResourceId = (monitored_resource_id) => ({
  type: GET_APP_DYNAMICS_MISSING_ALERT_BY_RESOURCE_ID,
  payload: monitored_resource_id
})

export const getAppDynamicsMissingAlertByResourceIdFail = error => ({
  type: GET_APP_DYNAMICS_MISSING_ALERT_BY_RESOURCE_ID_FAIL,
  payload: error
})

export const getAppDynamicsMissingAlertsByResourceIdSuccess = (response) => ({
  type: GET_APP_DYNAMICS_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS,
  payload: response
})

export const getAppDynamicsAllResourceAlertsPage = (data) => ({
  type: GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_PAGE,
  payload: data
})

export const getAppDynamicsAllResourceAlertsPageFail = error => ({
  type: GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  payload: error
})

export const getAppDynamicsAllResourceAlertsPageSuccess = (app_dynamics_all_resource_alerts) => ({
  type: GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  payload: app_dynamics_all_resource_alerts
})

export const getAppDynamicsAllResourceAlertsCountPage = (data) => ({
  type: GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_COUNT_PAGE,
  payload: data
})

export const getAppDynamicsAllResourceAlertsCountPageFail = error => ({
  type: GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL,
  payload: error
})

export const getAppDynamicsAllResourceAlertsCountPageSuccess = (app_dynamics_all_resource_alerts_count) => ({
  type: GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS,
  payload: app_dynamics_all_resource_alerts_count
})

export const postAppDynamicsAlert = (data) => ({
  type: POST_APP_DYNAMICS_ALERT,
  payload: data
})

export const postAppDynamicsAlertFail = error => ({
  type: POST_APP_DYNAMICS_ALERT_FAIL,
  payload: error
})

export const postAppDynamicsAlertsSuccess = (response) => ({
    type: POST_APP_DYNAMICS_ALERT_SUCCESS,
    payload: response
})

export const postAppDynamicsServiceMapping = (data) => ({
  type: POST_APP_DYNAMICS_SERVICE_MAPPING,
  payload: data
})

export const postAppDynamicsServiceMappingFail = error => ({
  type: POST_APP_DYNAMICS_SERVICE_MAPPING_FAIL,
  payload: error
})

export const postAppDynamicsServiceMappingSuccess = (response) => ({
  type: POST_APP_DYNAMICS_SERVICE_MAPPING_SUCCESS,
  payload: response
})

export const postAppDynamicsResourceOpsGenieTeamMapping = (data) => ({
  type: POST_APP_DYNAMICS_RESOURCE_OPSGENIE_TEAM_MAPPING,
  payload: data
})

export const postAppDynamicsResourceOpsGenieTeamMappingFail = error => ({
  type: POST_APP_DYNAMICS_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  payload: error
})

export const postAppDynamicsResourceOpsGenieTeamMappingSuccess = (response) => ({
  type: POST_APP_DYNAMICS_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  payload: response
})

export const postAppDynamicsResourcePagerdutyMapping = (data) => ({
  type: POST_APP_DYNAMICS_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  payload: data
})

export const postAppDynamicsResourcePagerdutyMappingFail = error => ({
  type: POST_APP_DYNAMICS_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  payload: error
})

export const postAppDynamicsResourcePagerdutyMappingSuccess = (response) => ({
  type: POST_APP_DYNAMICS_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  payload: response
})

export const getAllOrgAppDynamicsResourceTypes = () => ({
  type: GET_ALL_ORG_APP_DYNAMICS_RESOURCE_TYPES
})

export const getAllOrgAppDynamicsResourceTypesFail = error => ({
  type: GET_ALL_ORG_APP_DYNAMICS_RESOURCE_TYPES_FAIL,
  payload: error
})

export const getAllOrgAppDynamicsResourceTypesSuccess = orgAppDynamicsResourceTypes => ({
  type: GET_ALL_ORG_APP_DYNAMICS_RESOURCE_TYPES_SUCCESS,
  payload: orgAppDynamicsResourceTypes
})


 export const postAppDynamicsEnableDisableAlerts = (data) => ({
    type: POST_APP_DYNAMICS_ENABLE_DISABLE_ALERTS,
    payload: { data }
 })

 export const postAppDynamicsEnableDisableAlertsFail = error =>({
    type: POST_APP_DYNAMICS_ENABLE_DISABLE_ALERTS_FAIL,
    payload: error
 })

 export const postAppDynamicsEnableDisableAlertsSuccess = (response) => ({
    type: POST_APP_DYNAMICS_ENABLE_DISABLE_ALERTS_SUCCESS,
    payload: response
 })

 export const postAppDynamicsCreateResourceAlerts = (data) => ({
  type: POST_APP_DYNAMICS_CREATE_RESOURCE_ALERTS,
  payload: { data }
 })

 export const postAppDynamicsCreateResourceAlertsFail = error => ({
  type: POST_APP_DYNAMICS_CREATE_RESOURCE_ALERTS_FAIL,
  payload: error
 })

 export const postAppDynamicsCreateResourceAlertsSuccess = (response) => ({
  type: POST_APP_DYNAMICS_CREATE_RESOURCE_ALERTS_SUCCESS,
  payload: response
 })

 export const postAppDynamicsCreateDynamicAlert = (data) =>({
  type: POST_APP_DYNAMICS_CREATE_DYNAMIC_ALERT,
  payload: { data }
 })

export const postAppDynamicsCreateDynamicAlertSuccess = (response) => ({
  type: POST_APP_DYNAMICS_CREATE_DYNAMIC_ALERT_SUCCESS,
  payload: response
})

export const postAppDynamicsCreateDynamicAlertFail = error => ({
  type: POST_APP_DYNAMICS_CREATE_DYNAMIC_ALERT_FAIL,
  payload: error
})

export const getAppDynamicsAlerts = (monitored_resource_id) => (
    {
      type: GET_APP_DYNAMICS_ALERTS,
      payload: monitored_resource_id
    }
)

export const getAppDynamicsAlertsSuccess = app_dynamics_alerts => ({
  type: GET_APP_DYNAMICS_ALERTS_SUCCESS,
  payload: app_dynamics_alerts
})

export const getAppDynamicsAlertsFail = error => ({
  type: GET_APP_DYNAMICS_ALERTS_FAIL,
  payload: error
})

export const getAppDynamicsDynamicAlerts = (monitored_resource_id) => ({
  type: GET_APP_DYNAMICS_DYNAMIC_ALERTS,
  payload: monitored_resource_id
})

export const getAppDynamicsDynamicAlertsSuccess = app_dynamics_dynamic_alerts => ({
  type: GET_APP_DYNAMICS_DYNAMIC_ALERTS_SUCCESS,
  payload: app_dynamics_dynamic_alerts
})

export const getAppDynamicsDynamicAlertsFail = error => ({
  type: GET_APP_DYNAMICS_DYNAMIC_ALERTS_FAIL,
  payload: error
})

export const getAppDynamicsMissingDynamicAlerts = (monitored_resource_id) => ({
  type: GET_APP_DYNAMICS_MISSING_DYNAMIC_ALERTS,
  payload: monitored_resource_id
})

export const getAppDynamicsMissingDynamicAlertsFail = error => ({
  type: GET_APP_DYNAMICS_MISSING_DYNAMIC_ALERTS_FAIL,
  payload: error
})

export const getAppDynamicsMissingDynamicAlertsSuccess = app_dynamics_missing_dynamic_alerts => ({
  type: GET_APP_DYNAMICS_MISSING_DYNAMIC_ALERTS_SUCCESS,
  payload: app_dynamics_missing_dynamic_alerts
})

export const getAppDynamicsDefaultThreshold = threshold_type => ({
  type: GET_APP_DYNAMICS_DEFAULT_THRESHOLD,
  payload: threshold_type
})

export const getAppDynamicsDefaultThresholdFail = error => ({
  type: GET_APP_DYNAMICS_DEFAULT_THRESHOLD_FAIL,
  payload: error
})

export const getAppDynamicsDefaultThresholdSuccess = defaultThreshold => ({
  type: GET_APP_DYNAMICS_DEFAULT_THRESHOLD_SUCCESS,
  payload: defaultThreshold
})

export const getAppDynamicsThreshold = metric_id => ({
  type: GET_APP_DYNAMICS_THRESHOLD,
  payload: metric_id
})

export const getAppDynamicsThresholdFail = error => ({
  type: GET_APP_DYNAMICS_THRESHOLD_FAIL,
  payload: error
})

export const getAppDynamicsThresholdSuccess = appDynamicsThreshold => ({
  type: GET_APP_DYNAMICS_THRESHOLD_SUCCESS,
  payload: appDynamicsThreshold
})

export const getAppDynamicsResourceById = monitored_resource_id => ({
  type: GET_APP_DYNAMICS_RESOURCE_BY_ID,
  payload: monitored_resource_id
})

export const getAppDynamicsResourceByIdSuccess = app_dynamics_resource => ({
  type: GET_APP_DYNAMICS_RESOURCE_BY_ID_SUCCESS,
  payload: app_dynamics_resource
})

export const getAppDynamicsResourceByIdFail = error => ({
  type: GET_APP_DYNAMICS_RESOURCE_BY_ID_FAIL,
  payload: error
})

export const getAppDynamicsResourcesDefaultThresholdById = monitored_resource_id => (
    {
    type: GET_APP_DYNAMICS_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
    payload: monitored_resource_id
  }
)

export const getAppDynamicsResourcesDefaultThresholdByIdSuccess = app_dynamics_resource_default_threshold => ({
  type: GET_APP_DYNAMICS_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS,
  payload: app_dynamics_resource_default_threshold
})

export const getAppDynamicsResourcesDefaultThresholdByIdFail = error => ({
  type: GET_APP_DYNAMICS_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL,
  payload: error
})

export const getMissingADAlertsByResourceID = data => ({
  type: GET_AD_MISSING_ALERTS_BY_RESOURCE_ID,
  payload: data
})

export const getMissingADAlertsByResourceIDSuccess = app_dynamics_resource_missing_alerts => ({
  type: GET_AD_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  payload: app_dynamics_resource_missing_alerts,
})

export const getMissingADAlertsByResourceIDFail = error => ({
  type: GET_AD_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  payload: error,
})



export const getAppDynamicsAllBusinessTransactions = (data) => ({
  type: GET_APP_DYNAMICS_ALL_BUSINESS_TRANSACTIONS,
  payload: data
})

export const getAppDynamicsAllBusinessTransactionsFail = error => ({
  type: GET_APP_DYNAMICS_ALL_BUSINESS_TRANSACTIONS_FAIL,
  payload: error
})

export const getAppDynamicsAllBusinessTransactionsSuccess = (app_dynamics_all_resource_alerts) => ({
  type: GET_APP_DYNAMICS_ALL_BUSINESS_TRANSACTIONS_SUCCESS,
  payload: app_dynamics_all_resource_alerts
})


export const getAppDynamicsAllExternalServicesPage = (data) => ({
  type: GET_APP_DYNAMICS_ALL_EXTERNAL_SERVICES,
  payload: data
})

export const getAppDynamicsAllExternalServicesPageFail = error => ({
  type: GET_APP_DYNAMICS_ALL_EXTERNAL_SERVICES_FAIL,
  payload: error
})

export const getAppDynamicsAllExternalServicesPageSuccess = (app_dynamics_all_resource_alerts) => ({
  type: GET_APP_DYNAMICS_ALL_EXTERNAL_SERVICES_SUCCESS,
  payload: app_dynamics_all_resource_alerts
})

export const getADNonKeyTransactions = (page_filters) => ({
    type: GET_AD_NON_KEY_TRANSACTIONS,
    payload: page_filters
})

export const getADNonKeyTransactionsFail = error => ({
    type: GET_AD_NON_KEY_TRANSACTIONS_FAIL,
    payload: error
})

export const getADNonKeyTransactionsSuccess = (response) => ({
    type: GET_AD_NON_KEY_TRANSACTIONS_SUCCESS,
    payload: response
})

export const postMarkNonKeyTransactionAsBusinessTransaction = (data) => ({
    type: POST_MARK_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION,
    payload: data
})

export const postMarkNonKeyTransactionAsBusinessTransactionFail = error => ({
    type: POST_MARK_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_FAIL,
    payload: error
})

export const postMarkNonKeyTransactionAsBusinessTransactionSuccess = (response) => ({
    type: POST_MARK_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_SUCCESS,
    payload: response
})

